import { ComponentChangeType } from "@certa/studio-core";
import type { THEME } from "./colorPalette.constants";
import { PALETTE } from "./colorPalette.constants";
import type { NodeStyle } from "../engines/layoutEngine/layout.types";
import type { TextStyle } from "../engines/coreComponents/types";

export const getHighlightingStyle = (
  changeType: ComponentChangeType | undefined,
  theme: THEME
): Partial<NodeStyle> => {
  switch (changeType) {
    case ComponentChangeType.HOVERED:
      return {
        borderColor: PALETTE[theme].HOVER_ACTION_BORDER_COLOR,
        borderWidth: 1
      };
    case ComponentChangeType.ADDED:
      return {
        borderColor: PALETTE[theme].ADD_ACTION_BORDER_COLOR,
        borderWidth: 1
      };
    case ComponentChangeType.UPDATED:
      return {
        borderColor: PALETTE[theme].UPDATE_ACTION_BORDER_COLOR,
        borderWidth: 1
      };
    case ComponentChangeType.DELETED:
      return {
        borderColor: PALETTE[theme].DELETE_ACTION_BORDER_COLOR,
        borderWidth: 1
      };
    default:
      return {};
  }
};

// TODO: Remove when DS-4766 is resolved, https://thevetted.atlassian.net/browse/DS-5461
export const getFieldMaxLength = (
  ruleIndicatorCount: number
): Partial<TextStyle> => {
  switch (ruleIndicatorCount) {
    case 1:
      return {
        maxWidth: 190
      };
    case 2:
      return {
        maxWidth: 135
      };
    default:
      return {
        maxWidth: 200
      };
  }
};

// TODO: Remove when DS-4766 is resolved, https://thevetted.atlassian.net/browse/DS-5461
export const getFieldBodyMaxLength = (
  ruleIndicatorCount: number
): Partial<NodeStyle> => {
  switch (ruleIndicatorCount) {
    case 1:
      return {
        maxWidth: 215
      };
    case 2:
      return {
        maxWidth: 170
      };
    default:
      return {
        maxWidth: 235
      };
  }
};

// TODO: Remove when DS-4766 is resolved, https://thevetted.atlassian.net/browse/DS-5461
export const getStepTextMaxLength = (
  ruleIndicatorCount: number
): Partial<TextStyle> => {
  switch (ruleIndicatorCount) {
    case 1:
      return {
        maxWidth: 170
      };
    case 2:
      return {
        maxWidth: 120
      };
    default:
      return {
        maxWidth: 230
      };
  }
};

// TODO: Remove when DS-4766 is resolved, https://thevetted.atlassian.net/browse/DS-5461
export const getSwimlaneMaxLength = (
  ruleIndicatorCount: number
): Partial<TextStyle> => {
  switch (ruleIndicatorCount) {
    case 1:
      return {
        maxWidth: 200
      };
    case 2:
      return {
        maxWidth: 135
      };
    default:
      return {
        maxWidth: 240
      };
  }
};
